<app-common-modal #associateGCRModal [name]="'addOption'" [title]=" " [twoButtonsDialogs]="true" [withFooter]="false"
                  [size]="'modal-xxl'">

  <h4 modal-title class="modal-title" translate><span translate>T_OFFER_DATA_MANAGEMENT_ASSOCIATE_GCR</span></h4>
  <div modal-body>
    <div class="gcr-associate-modal-info">
      <label class="gcr-name-label" translate>T_OFFER_DATA_MANAGEMENT_GCR_NAME</label>
    </div>
    <div class="search-container gcr-field">
      <span class="search-prefix title-field" translate>T_NAME</span>
      <div class="autocomplete-wrapper input-field">
        <p-autoComplete [(ngModel)]="currentGcr"
                        scrollHeight="120px"
                        [size]="35"
                        [suggestions]="filteredAssociateGcrReferenceList"
                        (completeMethod)="filterAssociateGcrReference($event)"
                        [emptyMessage]="'T_OFFER_DATA_MANAGEMENT_NO_GCR_NAME_FOUND' | translate"
                        (ngModelChange)="onChangesGcrField($event);"
                        [virtualScroll]="true"
                        [dropdown]="true"
                        dropdownMode="blank">
        </p-autoComplete>
      </div>
      <span class="gcr-associate-title">
        <button class="action-button se-icon"
                *ngIf="isExistingGcr()"
                (click)="onClickEditAssociateGCRButton()">action_editor
        </button>

         <button class="action-button se-icon"
                 *ngIf="isExistingGcr()"
                 (click)="onClickDeleteConfirmationModal()">action_delete</button>
      </span>
    </div>
    <span *ngIf="containsInvalidGcrCharacters(currentGcr)"  class ="combination-disclaimer" translate>
        T_GCR_NAME_INVALID_CHARACTERS
    </span>
    <div class="gcr-associate-modal-table scrollable">
      <p-table #dt
               [value]="referencesList"
               responsiveLayout="stack"
               [globalFilterFields]="['reference','description','associateGcr']"
               [rowHover]="true"
               [scrollable]="true" scrollHeight="400px">
        <ng-template pTemplate="caption">
          <div class="table-caption">
            <div class="table-caption-search-bar p-input-icon-left ml-auto">
              <span class="pi pi-search table-caption-search-bar-search-icon title-field-search"></span>
              <input pInputText type="text" [(ngModel)]="searchTerm" (input)="onSearchInputChange($event)"
                     placeholder="Search" class="input-field-search"/>
            </div>
            <div class="select-all">
              <label class="label-text" translate>T_SELECT_ALL</label>
              <div>
                <label class="custom-checkbox-container">
                  <input type="checkbox" class="checkbox" [(ngModel)]="isSelectAllChecked" [checked]="isAllSelected()" (change)="toggleSelectAll()"/>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th scope="col" [pSortableColumn]="'reference'" [ngClass]="'reference-col'" translate>T_REFERENCE
              <p-sortIcon field="titleTranslated"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'description'" translate>T_DESCRIPTION
              <p-sortIcon field="fileName"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'alreadyExists'" translate [ngClass]="'checkbox-col'">
              T_ALREADY_ASSOCIATE_TO_GCR_EXISTS
            </th>
            <th scope="col" [pSortableColumn]="'associateToGCR'" [ngClass]="'checkbox-col'" translate>T_ASSOCIATE_TO_GCR
            </th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-ref>
          <tr [class.disabled-row]="ref.isDisabled">
            <td [ngClass]="'reference-col'"><span translate>{{ref.reference}}</span></td>
            <td><span translate>{{ref.description}}</span></td>
            <td [ngClass]="'checkbox-col'">
              <span *ngIf="ref.associateGcr">{{ref.associateGcr}}</span>
            </td>
            <td [ngClass]="'checkbox-col'">
              <label class="custom-checkbox-container">
                <input type="checkbox" class="checkbox" [(ngModel)]="ref.associateToCurrentGcr" name="associateToGCR" (change)="onAssociateGCRChange(ref)">
                <span class="checkmark"></span>
              </label></td>
          </tr>
        </ng-template>
      </p-table>
      <div class="gcr-associate-modal-footer">
        <button class="btn btn-default-white-background" (click)="hide()" translate>T_BUTTON_CLOSE</button>
        <button class="btn btn-default-white-background" [disabled]="!isValid()"
                (click)="saveOrUpdateGcr()" translate>T_BUTTON_APPLY
        </button>

      </div>
    </div>
  </div>
</app-common-modal>
<app-common-modal #deleteAssociateGcrModal
                  [name]="'deleteAssociateGcrModal'"
                  [title]="'T_CONFIRM_TITLE' | translate"
                  [description]="'T_DELETE_GCR_VALUE_MODAL_MESSAGE' | translate"
                  [twoButtonsDialogs]="true"
                  (onClickYesButton)="confirmDelete()"
                  (onClickNoButton)="closeDeleteModal()"
                  class = "sub-modal">
</app-common-modal>
<app-common-modal #editAssociateGcrModal
                  [name]="'editAssociateGcrModal'"
                  [title]="'T_BUTTON_EDIT' | translate"
                  [twoButtonsDialogs]="true"
                  [isYesDisabled]="!!editGcrError"
                  (onClickYesButton)="confirmEdit()"
                  (onClickNoButton)="closeEditModal()"
                  class = "sub-modal">
  <div modal-body>
    <input type="text" [(ngModel)]="gcrValue"  (ngModelChange)="onGcrValueChange($event)" class="form-control input-spacing"/>
    <span *ngIf="editGcrError" class="combination-disclaimer">{{ editGcrError }}</span>
  </div>
</app-common-modal>


